import React from 'react';

const SvgKm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KM_svg__b" fill="#fff">
        <use xlinkHref="#KM_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#FFCB49" mask="url(#KM_svg__b)" d="M0 0h28v5.333H0z" />
      <path fill="#DC1D34" mask="url(#KM_svg__b)" d="M0 9.333h28v5.333H0z" />
      <path fill="#4985D4" mask="url(#KM_svg__b)" d="M0 14.667h28V20H0z" />
      <path fill="#4BA343" mask="url(#KM_svg__b)" d="M0 20l13.333-10L0 0z" />
      <path
        d="M6.333 6.126a4.002 4.002 0 0 0 0 7.748 4 4 0 1 1 0-7.748zm1 1.874a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm0 2.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm0 2.666a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333z"
        fill="#FFF"
        mask="url(#KM_svg__b)"
      />
    </g>
  </svg>
);

export default SvgKm;
